import {
  DEFAULT_INSTALLER_FILENAME,
  DESKTOP_AGENT_TAB_INDEX,
  MIRA_TAB_INDEX,
  SETTINGS_SOURCES,
  SOURCE_TAB_OFFSET,
} from './constants'
import type {
  InstallerDownloadResponse,
  SettingsTabKey,
} from './types'

export const getSettingsTabIndex = (tab: string | null): number | null => {
  if (tab === 'mira') return MIRA_TAB_INDEX
  if (tab === 'desktop-agent') return DESKTOP_AGENT_TAB_INDEX

  const sourceIndex = SETTINGS_SOURCES.findIndex(source => source.key === tab)
  return sourceIndex >= 0 ? sourceIndex + SOURCE_TAB_OFFSET : null
}

export const getSettingsTabKey = (
  selectedIndex: number
): SettingsTabKey | null => {
  if (selectedIndex === MIRA_TAB_INDEX) return 'mira'
  if (selectedIndex === DESKTOP_AGENT_TAB_INDEX) return 'desktop-agent'
  return SETTINGS_SOURCES[selectedIndex - SOURCE_TAB_OFFSET]?.key ?? null
}

export const getStoredUserId = (): string => {
  try {
    const storedUser: unknown = JSON.parse(localStorage.getItem('user') ?? 'null')
    if (
      typeof storedUser === 'object' &&
      storedUser !== null &&
      'id' in storedUser
    ) {
      const id = storedUser.id
      return typeof id === 'string' || typeof id === 'number' ? String(id) : ''
    }
  } catch (error) {
    console.error('Failed to parse stored user', error)
  }

  return ''
}

export const downloadResponseFile = (
  response: InstallerDownloadResponse
): void => {
  const disposition = response.headers?.['content-disposition']
  const filenameMatch = disposition?.match(/filename="?([^";]+)"?/)
  const filename = filenameMatch?.[1]
    ? decodeURIComponent(filenameMatch[1])
    : DEFAULT_INSTALLER_FILENAME
  const url = window.URL.createObjectURL(new Blob([response.data]))
  const anchor = document.createElement('a')

  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  window.URL.revokeObjectURL(url)
}
